import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, catchError, of } from 'rxjs';

export const roleGuard = (allowedRoles: number[]): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Verificar si está autenticado
    if (!authService.isAuthenticated()) {
      return authService.refreshUserData().pipe(
        map(user => {
          if (!user) {
            return router.parseUrl('/auth');
          }
          
          const userRoleId = authService.getUserRole();
          if (userRoleId && allowedRoles.includes(userRoleId)) {
            return true;
          }
          
          return router.parseUrl('/admin');
        }),
        catchError(() => of(router.parseUrl('/auth')))
      );
    }

    // Si ya está autenticado, verificar el rol directamente
    const userRoleId = authService.getUserRole();
    if (userRoleId && allowedRoles.includes(userRoleId)) {
      return true;
    }

    // Redirigir al dashboard si no tiene permisos
    return router.parseUrl('/admin');
  };
};